import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import organizationServiceApi from 'shared/api/organization.service.api';

const ShareContext = createContext({
  magicLink: null,
});

export const ShareProvider = ({ children }) => {
  const [magicLink, setMagicLink] = useState(null);
  const organizationId = useSelector(state => state.organization?.id);

  useEffect(() => {
    async function fetchMagicLink() {
      setMagicLink(null);

      const { data, error } = await organizationServiceApi.getMagicUrl();
      if (!error && data?.url) {
        setMagicLink(data.url);
      }
    }
    fetchMagicLink();
  }, [organizationId]);

  return <ShareContext.Provider value={{ magicLink }}>{children}</ShareContext.Provider>;
};

export const useShare = () => {
  const context = useContext(ShareContext);
  if (context === undefined) {
    throw new Error('useShare must be used within a ShareProvider');
  }
  return context;
};
